import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet-async";

// Import the HeroSection directly (without lazy loading)
import HeroSection from "../components/HeroSection";

// Lazy load other components bruh
const InfrastructureSection = lazy(
  () => import("../components/Infrastructure"),
);
const GameSolutions = lazy(() => import("../components/GameSolutions"));
const GlobalLocations = lazy(() => import("../components/GlobalLocations"));
const EnterpriseSupport = lazy(() => import("../components/EnterpriseSupport"));
const ChooseUs = lazy(() => import("../components/ChooseUs"));

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>RaveNodes</title>
        <meta
          name="description"
          content="RaveNodes | Premium Ryzen-Powered Hosting for Minecraft, VPS, and Discord Bots. Enjoy blazing-fast servers in Germany with 2 Tbps DDoS protection, cutting-edge hardware, and unparalleled reliability for all your hosting needs."
        />
      </Helmet>
      {/* Renders the HeroSection now */}
      <HeroSection />
      {/* Wrap lazy components in Suspense :) */}
      <Suspense fallback={null}>
        {" "}
        {/* Use null to show nothing during loading */}
        <InfrastructureSection />
        <GlobalLocations />
        <ChooseUs />
        <GameSolutions />
        <EnterpriseSupport />
      </Suspense>
    </>
  );
};

export default HomePage;
